import type { GetAgentStatsState } from "./queries";

export type MetricBreakdownItem = {
    label: string;
    value: string | number;
};

export type CompletedTasksByTypeItem = MetricBreakdownItem & {
    label: "Calls" | "SMS" | "Emails" | "Others";
};

export function totalCount(data?: GetAgentStatsState): number {
    if (!data?.getDailyStats) {
        return 0;
    }

    const { getDailyStats } = data;
    let total = 0;
    // fallback just for safety
    total += getDailyStats.callCount || 0;
    total += getDailyStats.smsCount || 0;
    total += getDailyStats.emailCount || 0;
    total += getDailyStats.customCount || 0;
    total += getDailyStats.reminderCount || 0;
    total += getDailyStats.voicemailCount || 0;

    return total;
}

/** Same Calls / SMS / Emails / Others grouping as Queues Completed Tasks. */
export function completedTasksByType(data?: GetAgentStatsState): CompletedTasksByTypeItem[] {
    const stats = data?.getDailyStats;
    const callCount = stats?.callCount || 0;
    const smsCount = stats?.smsCount || 0;
    const emailCount = stats?.emailCount || 0;
    const othersCount = (stats?.customCount || 0) + (stats?.reminderCount || 0) + (stats?.voicemailCount || 0);

    // Ordered for the two-column grid so it reads Calls / SMS down the left, Emails / Others down the right.
    return [
        { label: "Calls", value: callCount },
        { label: "Emails", value: emailCount },
        { label: "SMS", value: smsCount },
        { label: "Others", value: othersCount },
    ];
}

/** Same metric definitions as Agents page; Answer Rate = call conversations / completed call tasks. */
export function conversationMetrics(data?: GetAgentStatsState): MetricBreakdownItem[] {
    const metrics = data?.getAuthenticatedUser?.metrics;
    const totalConversations = metrics?.totalConversations || 0;
    const totalTransfers = metrics?.totalTransfers || 0;
    const transferRate = metrics?.transferRate || 0;
    const callCount = data?.getDailyStats?.callCount || 0;
    const answerRate = callCount > 0 ? Math.round((totalConversations / callCount) * 100) : 0;

    // Ordered for the two-column grid so each rate sits beside its count.
    return [
        { label: "Call Conversations", value: totalConversations },
        { label: "Answer Rate", value: `${answerRate}%` },
        { label: "Transfers", value: totalTransfers },
        { label: "Transfer Rate", value: `${Math.round(transferRate)}%` },
    ];
}
